import request from '@/utils/request'

const bigdataUrl = '/tianshu-api/bigdata'

/** 查询看板核心单 */
export function getCoreTargets(year) {
  return request({
    url: bigdataUrl + '/target-system/dashboard/core-targets',
    method: 'get',
    params: { year }
  })
}

/** 查询看板年度单统计 */
export function getStatistics(year) {
  return request({
    url: bigdataUrl + '/target-system/dashboard/statistics',
    method: 'get',
    params: { year }
  })
}

/** 查询看板部门年度目标进度 */
export function getDepartmentProgress(year) {
  return request({
    url: bigdataUrl + '/target-system/dashboard/department-progress',
    method: 'get',
    params: { year }
  })
}

/** 按名称列表批量查询指标基础数据 */
export function getIndBaseDataByNames(names) {
  return request({
    url: bigdataUrl + '/ind-base-data/list/by-names',
    method: 'post',
    data: { names }
  })
}

/** 查询月报 （兼容旧接口） */
export function fetchTargetSystem() {
  return request({
    url: bigdataUrl + '/target-system/dashboard/core-targets',
    method: 'get'
  })
}
